<template>
  <div class="intervention-container">
    <div class="outer-circle">
      <div class="inner-circle">
        <img
          :src="
            require('../../assets/images/konstrukcija/desktop_pozicije/' +
              ('' + current_position).padStart(2, '0') +
              '_icon.svg')
          "
          alt=""
        />
      </div>
    </div>
    <div class="title">
      {{ uppercase(main_data.pos_position.select[current_position]) }}
    </div>
    <div class="description">
      {{ main_data["app_sklopovi_" + get_bottom_letter].select[get_status.top_image] }}
    </div>
    <div class="spacer-1"></div>
    <div class="subtitle">
      {{ main_data.list_solution.title }}
    </div>
    <img :src="get_image" alt="" class="full-image" />
    <perfect-scrollbar class="materijal-frame-container">
      <div
        :key="'materijal_loop' + get_status.top_image + '_' + materijal_loop + '_' + index"
        class="materijal-frame"
        v-for="(materijal_loop, index) in main_data.app_country_materijal.data[get_status.top_image][get_bottom_letter]"
      >
        <div class="materijal-left" @mouseenter="materijal = materijal_loop">
          <div class="materijal-title">{{ main_data.app_materijali.title[materijal_loop] }}</div>
          <div class="materijal-dimenzija">{{ main_data.app_materijali.select[materijal_loop] }}</div>
        </div>
        <div class="materijal-right">
          <img
            src="../../assets/images/external-link-symbol.svg"
            alt=""
            @click="gotolink(main_data.app_materijali.data[materijal_loop].web)"
          />
        </div>
      </div>
    </perfect-scrollbar>
    <div class="spacer-2"></div>
    <div class="footer">
      <div class="back" @click="$emit('back-step')">
        <img src="../../assets/images/desktop/edit.svg" alt="" class="back-left" />
        <div class="back-right">
          {{ main_data.list_change.title }}
        </div>
      </div>
      <div class="button" @click="$emit('confirm-step', 9)">
        {{ main_data.list_materijal_confirm.title }}
      </div>
    </div>
  </div>
</template>

<style>
.ps__thumb-x,
.ps__thumb-y {
  background-color: #4e8a9b !important;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: transparent !important;
}
</style>
<style lang="scss" scoped>
.intervention-container {
  width: 42rem;
  background-color: $main_header_middle;
  border-radius: 5rem;
  padding: 3.5rem 5.6rem 3rem 6.4rem;
  position: relative;

  .outer-circle {
    position: absolute;
    width: 10.3rem;
    top: 0;
    height: 10.3rem;
    left: -5.15rem;
    background-color: rgba(176, 210, 85, 0.51);
    border-radius: 50%;

    .inner-circle {
      position: absolute;
      width: 7.1rem;
      height: 7.1rem;
      top: calc(50% - 3.55rem);
      left: calc(50% - 3.55rem);
      background-color: $pos_back;
      border-radius: 50%;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 120%;
        max-width: 120%;
      }
    }
  }

  .spacer-1 {
    height: 1.5rem;
    border-bottom: 1px solid $main_header_light;
  }

  .title {
    margin-bottom: 3rem;
    font-family: F-Dem;
    font-size: 2.4rem;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: $desktop_button_text_inactive;
  }

  .description {
    font-size: 1.5rem;
    line-height: 1.2;
    text-align: left;
    color: $text_white;
  }

  .subtitle {
    font-family: F-Dem;
    font-size: 2.8rem;
    line-height: 0.64;
    text-align: left;
    color: $list_back;
    margin: 1rem 0 2.5rem 0;
  }

  .full-image {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
  }

  .materijal-frame-container {
    overflow-y: scroll;
    max-height: 14rem;
  }

  .materijal-frame {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 3rem;
    margin-bottom: 1rem;

    .materijal-left {
      font-family: F-Dem;
      font-size: 2.1rem;
      font-weight: bold;
      line-height: 0.71;
      text-align: left;
      color: $text_white;
      cursor: pointer;
    }

    .materijal-right {
      width: 3rem;
      align-self: stretch;
      cursor: pointer;

      img {
        width: 100%;
        max-width: 100%;
        height: auto;
      }
    }
  }

  .spacer-2 {
    height: 5.3rem;
    border-bottom: 1px solid $main_header_light;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5.6rem;
    margin-top: 3rem;

    .back {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 1rem;
      cursor: pointer;

      .back-left {
        width: 3.5rem;
        height: 3.5rem;
        max-width: 3.5rem;
      }

      .back-right {
        font-size: 2.1rem;
        line-height: 1.19rem;
      }
    }

    .button {
      width: 19rem;
      align-self: stretch;
      border-radius: 2.8rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 2.1rem;
      line-height: 1.19;
      color: $text_white;
      background-color: $calc_button;
      cursor: pointer;
    }
  }
}
</style>

<script>
import mixin from "../../lib/mixins.js";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

export default {
  mixins: [mixin],
  props: ["main_data", "current_position"],
  components: {
    PerfectScrollbar,
  },
  data: function () {
    return {
      materijal: "",
    };
  },
  computed: {
    get_bottom_letter: function () {
      return this.get_status.bottom_image === "b" || this.get_status.bottom_image === "c"
        ? this.get_status.bottom_image
        : "b";
    },
    get_status: function () {
      return this.main_data.pos_status.value[this.current_position];
    },
    get_image: function () {
      if (this.materijal) {
        let image = this.main_data.app_materijali.data[this.materijal].image;
        if (image) {
          return image;
        } else {
          image = this.main_data.app_country_slike.data[this.get_status.top_image][this.get_bottom_letter];
          if (image) {
            return image;
          }
        }
      }
      return "";
    },
  },
  methods: {
    gotolink: function (link) {
      window.open(link);
    },
  },
  mounted: function () {
    this.materijal = this.main_data.app_country_materijal.data[this.get_status.top_image][this.get_bottom_letter][0]
      ? this.main_data.app_country_materijal.data[this.get_status.top_image][this.get_bottom_letter][0]
      : "";
  },
};
</script>
